module.exports = __webpack_public_path__ + "img/1-1@4x.c4b9af9b.png";